import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import React from 'react';
import StatementSummaryFilters from './sections/StatementSummary.Filters';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import useStatementSummary, { StatementSummaryAction } from './StatementSummary.Hooks';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { HttpStatus, salesHomeRoute } from 'config/Api.Config';
import { isDesktop, isMobile } from 'react-device-detect';
import StatementSummaryCreate from './sections/StatementSummary.Create';
import StatementSummaryDelete from './sections/StatementSummary.Delete';
import StatementSummaryList from './sections/StatementSummary.List';
import StatementSummaryPrint from './sections/StatementSummary.Print';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const statementSummaryIndexRoute = salesHomeRoute + '/statement-summary/:action?/:id?';
export default function StatementSummaryIndex() {
  const { lang } = getLocales();
  const statementSummaryHook = useStatementSummary();
  const { permissions } = useAuthStore();

  if (!statementSummaryHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={statementSummaryHook}
        render={({ listApi, views, pageRouter }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.statementSummary} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <StatementSummaryFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions?.CREATE_STATEMENTSUMMARY}
                    data={{ action: StatementSummaryAction.CREATE }}
                  />
                </Box>
              </>
            }
            subHeader={isDesktop && <StatementSummaryFilters />}
            render={
              <>
                {views.create && <StatementSummaryCreate />}
                {views.print && <StatementSummaryPrint />}
                {views.delete && <StatementSummaryDelete />}
                <StatementSummaryList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
